import { render, staticRenderFns } from "./link_to_dashboards_modal.vue?vue&type=template&id=2a92a04b&scoped=true"
import script from "./link_to_dashboards_modal.vue?vue&type=script&lang=js"
export * from "./link_to_dashboards_modal.vue?vue&type=script&lang=js"
import style0 from "./link_to_dashboards_modal.vue?vue&type=style&index=0&id=2a92a04b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a92a04b",
  null
  
)

export default component.exports